import * as React from "react";
import { useCallback } from "react";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import { useSaveProject } from "../../../../../hooks/useSaveProject";
import CloseButton from "../../../../shared/ui/CloseButton/CloseButton";

interface SaveAsModalBodyProps {
    handleAfterSaveProject: () => void;
}
export function SaveAsModalBody(props: SaveAsModalBodyProps) {
    const { handleAfterSaveProject } = props;
    const saveProject = useSaveProject();

    const handleSaveProjectAsNew = useCallback(async () => {
        await saveProject({ isNewProject: true });
        handleAfterSaveProject();
    }, [saveProject, handleAfterSaveProject]);

    const handleRewriteProject = useCallback(async () => {
        await saveProject({ isNewProject: false });
        handleAfterSaveProject();
    }, [saveProject, handleAfterSaveProject]);

    return (
        <>
            <CloseButton style={{ top: "20px", right: "20px" }} onClick={handleAfterSaveProject} />
            <DialogTitle>{"Сохранение проекта"}</DialogTitle>
            <DialogContent>
                <DialogContentText>Вы хотите перезаписать проект или сохранить как новый?</DialogContentText>
            </DialogContent>
            <DialogActions sx={{ pl: 3, pr: 3, pb: 2 }}>
                <Button variant={"outlined"} onClick={handleRewriteProject}>
                    Перезаписать
                </Button>
                <Button variant={"contained"} onClick={handleSaveProjectAsNew}>
                    Сохранить как новый
                </Button>
            </DialogActions>
        </>
    );
}
